import { FC } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useQuery } from 'react-query';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { observer } from 'mobx-react-lite';
import { useMutation } from 'react-query';
import { useStyles } from './styles';
import { Paper } from '@material-ui/core';
import { Radio, RadioGroup, FormControlLabel, FormControl } from '@material-ui/core';
import Button from '@material-ui/core/Button';

export const SheduleFrequencySync: FC = observer(() => {
  const {
    importStore: {
      setStep,
      ldapGetSheduleOptions,
      syncShedule,
      updateSyncSchedule,
      ldapUpdateShedule,
      ldapGetSyncProcess,
      ldapLastSync: { lastSyncTime, status },
    },
    notificationStore: { openNotification },
    appPreloaderStore: { disablePreloader },
  } = useStore();

  const sheduleOptionsReq = useQuery('ldapGetSheduleOptions', () => ldapGetSheduleOptions(), {
    onError: () => openNotification('error', `Can't get last sync history`),
  });

  useQuery('ldapGetSyncProcess', () => ldapGetSyncProcess(), {
    onError: ({ message }: Error) => openNotification('error', message),
    refetchInterval: 60 * 1000,
    enabled: !!lastSyncTime && status === '0',
  });

  const { mutate: mutateUpdateShedule, isLoading } = useMutation('ldapUpdateShedule', () => ldapUpdateShedule(), {
    onMutate: () => {
      setStep('three_status');
    },
    onSuccess: () => {
      setStep('one');
      disablePreloader();
      openNotification('success', `Configuration is successfully updated.`);
    },
    onError: ({ message }: Error) => {
      setStep('two');
      disablePreloader();
      openNotification('error', message);
    },
  });

  useAppPreloader(sheduleOptionsReq.isFetching || isLoading);

  const classes = useStyles();
  return !sheduleOptionsReq.isFetching ? (
    <div className={classes.box}>
      <Paper className={classes.tabPaper}>
        <FormControl component='fieldset'>
          <RadioGroup name='radio-buttons-group'>
            {syncShedule.map((i) => (
              <FormControlLabel
                key={i.id}
                value={i.numberOfDays}
                control={
                  <Radio value={i.numberOfDays} checked={!!i.selected} onChange={() => updateSyncSchedule(i.id)} />
                }
                label={i.name}
              />
            ))}
          </RadioGroup>
        </FormControl>
      </Paper>
      <div className={classes.btnBox}>
        <Button className={classes.btn} onClick={() => setStep('three')}>
          Back
        </Button>
        <Button
          variant='contained'
          color='secondary'
          className={classes.btn}
          disabled={!isLoading ? false : true}
          onClick={() => mutateUpdateShedule()}>
          Save
        </Button>
      </div>
    </div>
  ) : null;
});
